import Vue from "vue";

const customCss = "data-custom-class";
const toggleTooltip = (el, disable) => {
	if (disable) {
		$(el).tooltip("disable");
	} else {
		// reinitialize tooltip, to update the title value
		$(el).tooltip("dispose");
		initTooltip(el);
	}
};
const initTooltip = (el) => {
	const payload = {};

	if (el.hasAttribute(customCss)) {
		payload.template = "<div class=\"tooltip " + el.getAttribute(customCss) + "\" role=\"tooltip\"><div class=\"arrow test\"></div><div class=\"tooltip-inner\"></div></div>";
	}

	$(el).tooltip(payload);
};

Vue.directive("tooltip", {
	unbind(el) {
		$(el).tooltip("dispose");
	},

	update(el, binding) {
		toggleTooltip(el, binding.value === false);
	},

	bind(el, binding) {
		if (window.matchMedia("(min-width: 768px)").matches) {
			setTimeout(() => {
				initTooltip(el);
				toggleTooltip(el, binding.value === false);
			}, 1);
		}
	}
});
